// import { FunctionComponent } from "react";
// import CalIcon from "../../assets/task/calendar-icon.svg";
// import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
// import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
// import userICon from "../../assets/task/uses-icon.svg";
// import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
// import { format } from "date-fns";

// interface ClosedGoalsProps {
//     cg: any;
//     handleGoalClick: (id: string) => void;
// }

// const ClosedGoals: FunctionComponent<ClosedGoalsProps> = ({
//     cg,
//     handleGoalClick
// }) => {
//     return (
//         <div className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2"
//             onClick={() => handleGoalClick(cg?.id)}
//         >
//             <div className="self-stretch rounded bg-honeydew border-lightseagreen border-solid border-[1px] flex flex-row items-start justify-center p-2 gap-2.5 text-lg">
//                 <b className="flex-1 relative">{cg?.title}</b>
//                 {/* <img className="w-[12px] rounded-[50px] h-[12px] overflow-hidden shrink-0" alt="" src={triPledots} /> */}
//             </div>
//             <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                 <div className="flex flex-row items-center justify-center gap-1.5">
//                     {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px]" alt="" src="Group 610.svg" /> */}
//                     <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
//                     <div className="relative">Schedule</div>
//                 </div>
//                 <div className="flex flex-row items-center justify-center text-dimgray">
//                     <div className="relative whitespace-pre-wrap">{`${format(cg?.start_date, 'MMM dd')} - ${format(cg?.end_date, 'MMM dd')}`}</div>
//                 </div>
//             </div>
//             <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                 <div className="flex flex-row items-center justify-center gap-1.5">
//                     {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="task_svgrepo.com.svg" /> */}
//                     <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIconcheck} />
//                     <div className="relative">Actual</div>
//                 </div>
//                 <div className="flex flex-row items-center justify-center text-dimgray">
//                     <div className="relative whitespace-pre-wrap">{`${format(cg?.actual_start_date, 'MMM dd')} - ${format(cg?.actual_end_date, 'MMM dd')}`}</div>
//                 </div>
//             </div>
//             <hr className="bdr-custom-taskcrad" />
//             <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                 <div className="flex flex-row items-center justify-center gap-1.5">
//                     {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="users_svgrepo.com.svg" /> */}
//                     <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userICon} />
//                     <div className="relative">Members</div>
//                 </div>
//                 <div className="flex flex-row items-center justify-center text-xs">
//                     <div className="w-6 relative h-6 shrink-0 ml-[-7px] flex justify-end items-center">
//                         <div className="mermbers_count_goal absolute top-[3px] left-[-35px]">
//                             <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                         </div>
//                         <div className="mermbers_count_goal absolute top-[3px] left-[-22px]">
//                             <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                         </div>
//                         <div className="mermbers_count_goal absolute top-[3px] left-[-8px]">
//                             <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userCricleimg} />
//                         </div>
//                         <div className="w-6 relative h-6 overflow-hidden shrink-0 ml-[-7px]">
//                             <div className="absolute top-[calc(50%_-_9px)] left-[calc(50%_-_6px)] mermbers_count_goal">{cg?.goal_members?.length}</div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
//                 <div className="flex flex-row items-center justify-center gap-1.5">
//                     {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
//                                                             <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
//                                                             <img className="w-5 relative max-h-full overflow-hidden shrink-0" alt="" src="task-square_svgrepo.com.svg" /> */}
//                     <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={taskIcons} />
//                     <div className="relative">Tasks</div>
//                 </div>
//                 <div className="flex flex-row items-center justify-center text-dimgray">
//                     <div className="relative">{`${cg?.number_of_completed_tasks}/${cg?.number_of_tasks}`}</div>
//                 </div>
//             </div>
//             <hr className="bdr-custom-taskcrad" />
//             {/* <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2 text-dimgray">
//                                                         <div className="relative">Progress</div>
//                                                         <div className="flex-1 relative h-0.5">
//                                                             <div className="absolute top-[0px] left-[0px] rounded-[25px] bg-whitesmoke-300 w-[182px] h-0.5" />
//                                                             <div className="absolute top-[0px] left-[0px] rounded-[25px] bg-lightseagreen w-[91.7px] h-0.5" />
//                                                         </div>
//                                                     </div> */}
//             <hr className="bdr-custom-taskcrad" />
//             {/* <div className="rounded-[100px] bg-crimson-100 flex flex-row items-center justify-center py-1 px-2 text-sm text-white">
//                                             <div className="relative font-semibold">Delayed</div>
//                                         </div> */}
//             {cg?.goal_tags_values?.length > 0 && (
//                 cg?.goal_tags_values?.map((cg: any) => {
//                     return (
//                         <div className="rounded-[100px] bg-crimson flex flex-row items-center justify-center py-1 px-2 text-sm text-white right_status_clockout">
//                             <div className="relative">{cg?.tags_name}
//                             </div>
//                         </div>
//                     )

//                 })
//             )}
//         </div>
//     )
// }

// export default ClosedGoals;

import { FunctionComponent, useState, useRef, useEffect } from "react"; // Import useState, useRef, useEffect
import CalIcon from "../../assets/task/calendar-icon.svg";
import userCricleimg from "../../assets/task/user-circle_svgrepo.com.svg";
import taskIcons from "../../assets/task/task-square_svgrepo.com.svg";
import userICon from "../../assets/task/uses-icon.svg";
import CalIconcheck from "../../assets/task/task_svgrepo.com.svg";
import { format } from "date-fns";
import triPledots from "../../assets/task/triple_dot.svg"; // Make sure this import is present
import { useNavigate } from "react-router-dom";

interface ClosedGoalsProps {
  cg: any;
  handleGoalClick: (id: string) => void;
  projectMembers: any;
}

const ClosedGoals: FunctionComponent<ClosedGoalsProps> = ({
  cg,
  handleGoalClick,
  projectMembers,
}) => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLImageElement>(null); // Ref for the triple dot button

  const toggleMenu = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the goal click from being triggered
    setShowMenu((prev) => !prev);
  };

  // Close the menu if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the click is outside the menu AND not on the toggle button
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Optional: Functions for handling menu actions (implement in parent or here with callbacks)
  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (cg?.is_template) {
      navigate("/edit_goal_from_template", {
        state: {
          goalID: cg?.id,
          projectName: cg?.project_name,
        },
      });
    } else {
      navigate("/edit_goal", {
        state: {
          projectName: cg?.project_name,
          projectID: cg?.project_id,
          goalID: cg?.id,
          goalMembers: cg?.goal_members,
          projectMembers: projectMembers,
        },
      });
    }

    setShowMenu(false);
  };

  // const handleArchive = (e: React.MouseEvent) => {
  //     e.stopPropagation();
  //     console.log(`Archive Goal: ${cg?.id}`);
  //     // onArchiveGoal(cg?.id); // Call a prop function to handle the archive
  //     setShowMenu(false);
  // };

  return (
    <div
      className="self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2 cursor-pointer" // Added cursor-pointer
      onClick={() => handleGoalClick(cg?.id)}
    >
      <div className=" parent-dv-item  self-stretch rounded bg-honeydew border-lightseagreen border-solid border-[1px] flex flex-row items-start justify-between p-2 gap-2.5 text-lg relative overflow-hidden">
        {" "}
        {/* Changed justify-center to justify-between and added relative */}
        <b className="flex-1 relative">{cg?.title}</b>
        <img
          ref={buttonRef} // Assign the ref to the button
          className="w-4 h-4 relative rounded-[50px] overflow-hidden shrink-0 cursor-pointer"
          alt="Options"
          src={triPledots}
          onClick={toggleMenu}
        />
        {/* Menu Pop-up */}
        {showMenu && (
          <div
            ref={menuRef} // Assign the ref to the menu container
            className="absolute right-0 top-full mt-2 w-32 bg-white border border-gray-200 rounded shadow-lg z-10" // Adjust styling as needed
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the menu
          >
            <div
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
              onClick={handleEdit}
            >
              Edit Goal
            </div>
            {/* <div
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                            onClick={handleArchive}
                        >
                            Archive Goal
                        </div> */}
          </div>
        )}
      </div>
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        {/* <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                    <div className="relative">Outcome</div>
                </div> */}
        <div className="flex flex-row items-center justify-center text-dimgray">
          <b className="relative whitespace-pre-wrap">
            {cg?.goal_static_outcome}
          </b>
        </div>
      </div>
      <hr className="bdr-custom-taskcrad" />
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        <div className="flex flex-row items-center justify-center gap-1.5">
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src={CalIcon}
          />
          <div className="relative">Schedule</div>
        </div>
        <div className="flex flex-row items-center justify-center text-dimgray">
          <div className="relative whitespace-pre-wrap">{`${format(cg?.start_date, "MMM dd")} - ${format(cg?.end_date, "MMM dd")}`}</div>
        </div>
      </div>
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        <div className="flex flex-row items-center justify-center gap-1.5">
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src={CalIconcheck}
          />
          <div className="relative">Actual</div>
        </div>
        <div className="flex flex-row items-center justify-center text-dimgray">
          <div className="relative whitespace-pre-wrap">{`${format(cg?.actual_start_date, "MMM dd")} - ${format(cg?.actual_end_date, "MMM dd")}`}</div>
        </div>
      </div>
      <hr className="bdr-custom-taskcrad" />
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        <div className="flex flex-row items-center justify-center gap-1.5">
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src={userICon}
          />
          <div className="relative">Facilitator</div>
        </div>
        <div className="flex flex-row items-center justify-center text-dimgray">
          <div className="relative">{cg?.created_by_name || "N/A"}</div>
        </div>
      </div>
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        <div className="flex flex-row items-center justify-center gap-1.5">
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src={userICon}
          />
          <div className="relative">Members</div>
        </div>
        <div className="relative group inline-block">
          {/* Count */}
          <div className="px-2 py-1 bg-gray-100 rounded-lg border text-sm cursor-pointer count-dark-bg-dv">
            {cg?.goal_members?.length || 0}
          </div>

          {/* Hover Tooltip/List */}
          {cg?.goal_members?.length > 0 && (
            <div className="absolute top-8 left-0 hidden group-hover:block bg-white shadow-lg rounded-lg p-2 w-48 z-50">
              <ul className="text-sm text-gray-700 max-h-40 overflow-y-auto">
                {cg?.goal_members?.map((member: any, i: number) => (
                  <li
                    key={i}
                    className="py-1 px-2 hover:bg-gray-100 rounded dark:text-white"
                  >
                    {member?.member_name || `Member ${i + 1}`}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        {/* <div className="flex flex-row items-center justify-center text-xs">
                    <div className="w-6 relative h-6 shrink-0 ml-[-7px] flex justify-end items-center">
                        <div className="flex flex-row items-start justify-end">
                            {cg?.goal_members?.slice(0, 3).map((member: any, index: number) => (
                                <div key={index} className={`mermbers_count_goal absolute top-[3px] left-[${-35 + (index * 13)}px]`}>
                                    <img className="w-5 relative h-5 overflow-hidden shrink-0" alt="" src={userCricleimg} />
                                </div>
                            ))}
                            {cg?.goal_members?.length > 3 && (
                                <div className="w-6 relative h-6 overflow-hidden shrink-0 ml-[-7px]">
                                    <div className="absolute top-[calc(50%_-_9px)] left-[calc(50%_-_6px)] mermbers_count_goal">
                                        +{cg?.goal_members?.length - 3}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div> */}
      </div>
      <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
        <div className="flex flex-row items-center justify-center gap-1.5">
          <img
            className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer"
            alt=""
            src={taskIcons}
          />
          <div className="relative">Tasks</div>
        </div>
        <div className="flex flex-row items-center justify-center text-dimgray">
          <div className="relative">{`${cg?.number_of_completed_tasks}/${cg?.number_of_tasks}`}</div>
        </div>
      </div>
      <hr className="bdr-custom-taskcrad" />
      {/* The progress bar section was commented out in your original code for ClosedGoals, so I've kept it that way. */}
      {/* The original Delayed tag rendering was also commented out, so I'm removing it and mapping all other tags. */}
      {cg?.goal_tags_values?.length > 0 &&
        cg?.goal_tags_values?.map((tag: any) => {
          // Renamed 'cg' to 'tag' for clarity in map
          // Assuming you only want to display relevant tags for closed goals,
          // you might still want to filter out certain tags if they don't apply.
          // For now, I'm displaying all tags present in goal_tags_values.
          return (
            <div
              key={tag.id} // Added key for list rendering
              className="rounded-[100px] bg-crimson flex flex-row items-center justify-center py-1 px-2 text-sm text-white right_status_clockout"
            >
              <div className="relative">{tag?.tags_name}</div>
            </div>
          );
        })}
    </div>
  );
};

export default ClosedGoals;
